'use es6';

import { AD_NETWORK_GOOGLE, AD_OBJECT_KEYWORD } from 'reference-resolvers/constants/ReferenceObjectTypes';
import createBatchedReferenceResolver from 'reference-resolvers/lib/createBatchedReferenceResolver';
import { ADS_GOOGLE_KEYWORDS } from 'reference-resolvers/constants/CacheKeys';
import { createFetchAdsObjectSearchPageForNetwork, createFetchAdsObjectsByIdsForNetwork, fetchAdsObjectsByIdsForNetwork, fetchAdsObjectSearchPageForNetwork } from 'reference-resolvers/api/AdsEntityApi';
export const createAdsGoogleKeywordsReferenceResolver = options => createBatchedReferenceResolver(Object.assign({
  cacheKey: ADS_GOOGLE_KEYWORDS,
  createFetchByIds: opts => createFetchAdsObjectsByIdsForNetwork(opts)(AD_NETWORK_GOOGLE, AD_OBJECT_KEYWORD),
  createFetchSearchPage: opts => createFetchAdsObjectSearchPageForNetwork(opts)(AD_NETWORK_GOOGLE, AD_OBJECT_KEYWORD),
  fetchByIds: fetchAdsObjectsByIdsForNetwork(AD_NETWORK_GOOGLE, AD_OBJECT_KEYWORD),
  fetchSearchPage: fetchAdsObjectSearchPageForNetwork(AD_NETWORK_GOOGLE, AD_OBJECT_KEYWORD)
}, options));
export default createAdsGoogleKeywordsReferenceResolver();